import { CardFormFieldNames } from "./enums";

export const HOSTED_FIELD_NAME_KEYS: string[] = [
     CardFormFieldNames.CardNumber,
     CardFormFieldNames.CardExpiration,
     CardFormFieldNames.CardCvv,
     CardFormFieldNames.CardHolderName,
];